import { StateCreator } from "zustand"
import { UserType, UserEmptyState } from "../types/users/userTypes"

export type AuthSliceType = {
    user: UserType,
    isAuthenticated: boolean,
    login: (user: UserType) => void
    logout: () => void
    changeUserId: (userId: string) => void
}

export const createAuthSliceType: StateCreator<AuthSliceType> = (set) => ({
    user: UserEmptyState,
    isAuthenticated: false,
    login: (user: UserType) => set(() => ({
        user,
        isAuthenticated: true
    })),
    logout: () => set(() => ({
        user: UserEmptyState,
        isAuthenticated: false
    })),
    changeUserId: (userId: string) => set((state) => ({
        user: { ...state.user, usuarioId: userId }
    }))
})